import { gql } from '@apollo/client';

export const CALCULATE_KPI_MUTATION = gql`
  mutation calculateKpiConfig($id: Int!) {
    p {
      calculateKpiConfig(id: $id) {
        success
        message {
          code
          message
        }
        content
      }
    }
  }
`;
